<!--
 * @Descripttion: 
 * @version: 
 * @Author: Qf
 * @Date: 2022-09-18 12:32:21
 * @LastEditTime: 2022-09-19 09:55:56
 * @LastEditors: Qf
-->
<template>
  <section class="service">
    <div class="title">
      <p>换<span>新</span>服务保障</p>
    </div>
    <div class="box">
      <div class="item">
        <div class="icon"></div>
        <p>官方自营</p>
        <p>强强联合 信任无忧</p>
      </div>
      <div class="item">
        <div class="icon"></div>
        <p>价格保护</p>
        <p>官网授权 合作报价</p>
      </div>
      <div class="item">
        <div class="icon"></div>
        <p>专业质检</p>
        <p>标准化检测专业质检团队</p>
      </div>
      <div class="item">
        <div class="icon"></div>
        <p>隐私安全</p>
        <p>所有数据 深度粉碎</p>
      </div>
    </div>
  </section>
</template>
<script>
export default {

}
</script>
<style scoped>
.service {
  position: relative;
  margin: 112px auto 0;
  width: 1200px;
  background: #FFFFFF;
  box-shadow: 3px 0px 21px 0px rgba(51,51,51,0.22);
  border-radius: 36px;
  padding: 76px 110px 50px;
}
.service .title {
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 765px;
  height: 70px;
  background: linear-gradient(90deg, #FD704D 0%, #FA4448 100%);
  border-radius: 35px;

}
.service .title p{
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 32px;
  line-height: 65px;
  height: 65px;
  color: #fff;
  font-weight: 500;
  font-style: italic;
  text-shadow: 3px 0px 6px rgba(51,51,51,0.47);
}
.service .title p span{
  font-size: 65px;

}
.service .box {
  display: flex;
  justify-content: space-between;
}
.service .box .item {
  width: 198px;
  text-align: center;
  background: #F5F8FA;
  box-shadow: 3px 0px 21px 0px rgba(51,51,51,0.22);
  border-radius: 16px;
  padding: 48px 0;
}
.service .box .item .icon {
  width: 62px;
  height: 62px;
  margin: 0 auto;
  display: block;
  background-image: url(https://image.suhuishou.com/attached/upload/20220918/20220918224340_1509.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 49px 61px;
}
.service .box .item:nth-child(2) .icon {
  background-image: url(https://image.suhuishou.com/attached/upload/20220918/20220918224340_5984.png);
  background-size: 56px 55px;
}
.service .box .item:nth-child(3) .icon {
  background-image: url(https://image.suhuishou.com/attached/upload/20220918/20220918224340_3015.png);
  background-size: 48px 48px;
}
.service .box .item:nth-child(4) .icon {
  background-image: url(https://image.suhuishou.com/attached/upload/20220918/20220918224340_6052.png);
  background-size: 46px 56px;
}
.service .box .item p:nth-child(2) {
  font-size: 24px;
  line-height: 87px;
  font-weight: 500;
  color: #333333;
  padding-top: 17px;
}
.service .box .item p:nth-child(3) {
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  line-height: 1em;
}
</style>